import { action } from 'satcheljs';
import { UserContext } from '../store/schema';

export const onAuthLogout = action('onAuthLogout', ({ isTokenExpired = false } = {}) => ({ isTokenExpired }));
export const onUserContextChanged = action('onUserContextChanged', (userDetails?: UserContext) => ({ userDetails }));
